import { makeStyles } from '@material-ui/core'
import type { FocalCircle } from '@paintscout/util/util'
import { getFocalCrop } from '@paintscout/util/util'
import { imageCrossOrigin, retryCorsImageOnError } from '@paintscout/ui/util/corsImage'
import React, { useState } from 'react'

const useStyles = makeStyles(
  {
    frame: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '50%',
      flexShrink: 0
    },
    image: {
      position: 'absolute',
      display: 'block',
      maxWidth: 'none',
      // until the photo's size is known, cover the frame centred
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  },
  { name: 'FocalCropPreview' }
)

export interface FocalCropPreviewProps {
  src: string
  focalPoint: FocalCircle
  /** Diameter in px */
  size?: number
}

/** The photo as presentations show it: round, showing only what is inside the saved circle */
export default function FocalCropPreview({ src, focalPoint, size = 140 }: FocalCropPreviewProps) {
  const classes = useStyles()
  const [natural, setNatural] = useState<{ width: number; height: number } | null>(null)
  const crop = getFocalCrop({
    options: { objectPositionX: focalPoint.x, objectPositionY: focalPoint.y, focalSize: focalPoint.size },
    imageWidth: natural?.width,
    imageHeight: natural?.height,
    frameAspect: 1,
    fill: 1
  })

  return (
    <div className={classes.frame} style={{ width: size, height: size }}>
      <img
        src={src}
        alt=""
        className={classes.image}
        draggable={false}
        crossOrigin={imageCrossOrigin()}
        onError={retryCorsImageOnError}
        onLoad={(e) => setNatural({ width: e.currentTarget.naturalWidth, height: e.currentTarget.naturalHeight })}
        style={
          crop
            ? { left: `${crop.left}%`, top: `${crop.top}%`, width: `${crop.width}%`, height: `${crop.height}%` }
            : undefined
        }
      />
    </div>
  )
}
